import React from "react";
import { Link } from "react-router-dom";
import { RiShoppingCart2Fill } from "react-icons/ri";
import { MdSwitchAccount } from "react-icons/md";
import { useSelector } from "react-redux";
import { BsSuitHeartFill, BsWhatsapp } from "react-icons/bs";


const SpecialCase = () => {
  const products = useSelector((state) => state.orebiReducer.products);
  const wishlist = useSelector((state) => state.orebiReducer.wishlist);
  return (
    <div className="fixed bottom-0 right-2 z-20 flex flex-row gap-2">
      <Link to="/signin">
        <div className="bg-white w-16 h-[70px] rounded-md flex flex-col gap-1 text-[#33475b] justify-center items-center shadow-testShadow overflow-x-hidden group cursor-pointer">
          <div className="flex justify-center items-center">
            <MdSwitchAccount className="text-2xl -translate-x-12 group-hover:translate-x-3 transition-transform duration-200" />
            <MdSwitchAccount className="text-2xl -translate-x-3 group-hover:translate-x-12 transition-transform duration-200" />
          </div>
          <p className="text-xs font-semibold font-titleFont">Profile</p>
        </div>
      </Link>
      
      <Link to="/wishlist">
        <div className="bg-white w-16 h-[70px] rounded-md flex flex-col gap-1 text-[#33475b] justify-center items-center shadow-testShadow overflow-x-hidden group cursor-pointer relative">
          <div className="flex justify-center items-center">
            <BsSuitHeartFill className="text-2xl -translate-x-12 group-hover:translate-x-3 transition-transform duration-200" />
            <BsSuitHeartFill className="text-2xl -translate-x-3 group-hover:translate-x-12 transition-transform duration-200" />
          </div>
          <p className="text-xs font-semibold font-titleFont">WishList</p>
          {wishlist.length > 0 && (
            <p className="absolute top-1 right-2 bg-primeColor text-white text-xs w-4 h-4 rounded-full flex items-center justify-center font-semibold">
              {wishlist.length}
            </p>
          )}
        </div>
      </Link>
      <Link to="/cart">
        <div className="bg-white w-16 h-[70px] rounded-md flex flex-col gap-1 text-[#33475b] justify-center items-center shadow-testShadow overflow-x-hidden group cursor-pointer relative">
          <div className="flex justify-center items-center">
            <RiShoppingCart2Fill className="text-2xl -translate-x-12 group-hover:translate-x-3 transition-transform duration-200" />
            <RiShoppingCart2Fill className="text-2xl -translate-x-3 group-hover:translate-x-12 transition-transform duration-200" />
          </div>
          <p className="text-xs font-semibold font-titleFont">Buy Now</p>
          {products.length > 0 && (
            <p className="absolute top-1 right-2 bg-primeColor text-white text-xs w-4 h-4 rounded-full flex items-center justify-center font-semibold">
              {products.length}
            </p>
          )}
        </div>
      </Link>
      <Link to="https://wa.me/+919080857464">
  <div style={{ backgroundColor: '#25D366' }} className="w-16 h-[70px] rounded-md flex flex-col gap-1 text-[#33475b] justify-center items-center shadow-testShadow overflow-x-hidden group cursor-pointer relative">
    <div className="flex justify-center items-center">
      <BsWhatsapp className="text-2xl -translate-x-12 group-hover:translate-x-3 transition-transform duration-200" />
      <BsWhatsapp className="text-2xl -translate-x-3 group-hover:translate-x-12 transition-transform duration-200" />
    </div>
    <p className="text-xs font-semibold font-titleFont">Whatsapp</p>
  </div>
</Link>
    </div>
  );
};

export default SpecialCase;
